export const EUR = 'EUR';
export const EUR_SYMBOL = '€';
export const PERCENTAGE = '%';
